import { render, staticRenderFns } from "./PPC.vue?vue&type=template&id=4a002666&"
import script from "./PPC.vue?vue&type=script&lang=js&"
export * from "./PPC.vue?vue&type=script&lang=js&"
import style0 from "./PPC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports